
import { Employer } from "./model.employer";
import { Conjoint } from "./model.conjoint";
import { InfoEnregistrement} from "./infoEnregistrement";
export class Agenda {
	agenda_id:any;
	agenda_etat:any;
	agenda_date_consultation:Date;
	agenda_date_rendez_vous:Date;
	agenda_heure_rendez_vous:Date;
	agenda_type_consultation:any;
	id_employer : any;
	id_motif_consultation : any;
	id_agent : any;
	tension:any;
	temperature:any;
	pois:any;
	poids : any;
 	petit_client_id : String;
	employer:Employer;
	conjoints:Conjoint;
	taille : any;
	rendez_vous_id : number;
	heure : String;
	total : any;
	strHeure :  String;
	strJour : String;
	strMois : String;
	infoEnregistrement : InfoEnregistrement=new InfoEnregistrement();
	constructor($agenda_id:any,
		$employer:Employer,
		$conjoints:Conjoint){
			this.agenda_id=$agenda_id;
			this.employer=$employer;
			this.conjoints=$conjoints;
		}

	

   
}
